import axios from 'axios'
import * as validator from '../../reusable-components/Validation/Validations'
const clientList = []
const clientLocationList = []
export const ADD_NOTES_FORM_INPUTS = (programsList, scoringMethodList,serviceDescriptionList, addressList) => {
  return [
    {
      sectionHeading: 'Details',
      rowNumber: 3,
    },
    {
      label: 'Program',
      name: 'programId',
      type: 'select',
      options: programsList,
      required: true,
      rowNumber: 4,
      onChange: (programId, b) => getClientsUnderAProgram(programId, b),
    },
    {
      label: 'Client',
      name: 'clientId',
      type: 'select',
      options: clientList,
      disabled: false,
      required: true,
      rowNumber: 4,
    },
    {
      label: 'Note Name',
      name: 'noteName',
      type: 'text',
      required: true,
      rowNumber: 4,
      validation: validator.NAME_VALIDATION,
    },
    // {
    //   label: 'Start Date',
    //   name: 'startDate',
    //   type: 'date',
    //   required: true,
    //   rowNumber: 3,
    // },
    // {
    //   label: 'End Date',
    //   name: 'endDate',
    //   type: 'date',
    //   required: true,
    //   rowNumber: 3,
    // },
    // {
    //   label: 'Target Completion Date',
    //   name: 'targetCompletionDate',
    //   type: 'date',
    //   required: true,
    //   rowNumber: 4,
    // },
    // {
    //   label: 'Location',
    //   name: 'location',
    //   type: 'select',
    //   options: addressList,
    //   required: true,
    //   rowNumber: 4,
    // },
    {
      sectionHeading: 'Scoring Method',
      rowNumber: 5,
    },
    {
      label: 'Method',
      name: 'scoringMethod',
      type: 'select',
      options: scoringMethodList,
      required: true,
      rowNumber: 5,
    },
    {
      sectionHeading: 'Service Description',
      rowNumber: 5,
    },
    {
      label: 'Service Description',
      name: 'serviceId',
      type: 'select',
      options: serviceDescriptionList,
      required: true,
      rowNumber: 5,
    },
    {
      sectionHeading: 'Other Details',
      rowNumber: 6,
    },
    {
      label: 'Long Term Objectives',
      name: 'longTermObjectives',
      type: 'textarea',
      required: true,
      rowNumber: 7,
      minRows: 4,
    },
    {
      label: 'Goals/Service',
      name: 'goals',
      type: 'textarea',
      required: true,
      rowNumber: 8,
    },
    {
      label: 'Reason For Notes',
      name: 'reasonForNotes',
      type: 'textarea',
      required: true,
      rowNumber: 9,
    },
    {
      label: 'Criteria For Completion',
      name: 'criteriaForCompletion',
      type: 'textarea',
      required: true,
      rowNumber: 10,
    },
    {
      label: 'Materials Required',
      name: 'materialsRequired',
      type: 'textarea',
      required: true,
      rowNumber: 11,
    },
    {
      label:"Client lives with:",
      name:"clientLivesWith",
      rowNumber: 12,
      type:"select",
      options:[
        {label:"Client Lives Alone", value:"alone"},
        {label:"Client Lives With family, but family is unavailable", value:"withfamilybutunavail"},
        {label:"Client Lives With family, but family is unable to provide care", value:"withfamilybutunabletocare"},
        {label:"Client Lives With family, but family needs assistance", value:"withfamilybutassistance"},
      ]
    },
    {
      sectionHeading: 'Goals',
      rowNumber: 13,
    },
    {
      type: 'CaregiverNotesDialog',
      rowNumber: 26,
      isDisabled: false,
    },
  ]
}

export const ADD_NEW_SCORING_METHOD = () => {
  return [
    {
      label: 'Scoring Method Name',
      name: 'scoringMethodName',
      type: 'text',
      required: true,
      rowNumber: 1,
    },
    {
      sectionHeading: 'Scoring Method Levels',
      rowNumber: 2,
    },
  ]
}

const getClientsUnderAProgram = async (programId, b) => {
  clientList.length = 0;
  clientLocationList.length = 0;

  try {
    const [clientResponse, addressResponse] = await Promise.all([
      axios.get(`/clients/getClientsUnderAProgram/${programId}`),
      axios.get('/address/getAll')
    ]);
    clientResponse.data?.clients?.forEach((eachClient) => {
      clientList.push({
        label: `${eachClient.firstName} ${eachClient.lastName}`,
        value: eachClient._id,
      });
    });
  } catch (error) {
    console.error('Error fetching data:', error);
  }
};

export const ADD_NOTE_ENTRY_FORM_INPUTS = (name: string,clientName: string) => {
  return [
    {
      label: 'Client Name',
      name: 'name',
      type: 'textLabel',
      required: true,
      rowNumber: 2,
      className: `col-lg-6 col-md-6 col-sm-12 col12`,
      value: clientName
    },
    // {
    //   label: 'Data Collection Date',
    //   name: 'startDate',
    //   type: 'date',
    //   required: true,
    //   rowNumber: 1,
    //   className: `col-lg-6 col-md-6 col-sm-12 col-12`,
    //   placeholder: 'MM-DD-YYYY', 
    // },
    // {
    //   label: 'Begin Time',
    //   name: 'beginTime',
    //   type: 'time',
    //   required: true,
    //   rowNumber: 2,
    //   className: `col-lg-6 col-md-6 col-sm-12 col-12`,
    // },
    // {
    //   label: 'End Time',
    //   name: 'endTime',
    //   type: 'time',
    //   required: true,
    //   rowNumber: 2,
    //   className: `col-lg-6 col-md-6 col-sm-12 col-12`,
    // },
    // {
    //   label: 'Location',
    //   name: 'location',
    //   type: 'textLabel',
    //   required: true,
    //   rowNumber: 4,
    //   className: `col-lg-6 col-md-12 col-sm-12 col-12`,
    //   value: location
    // },
    {
      label: 'Entered By',
      name: 'enteredBy',
      type: 'textLabel',
      // required: true,
      rowNumber: 2,
       className: `col-lg-6 col-md-12 col-sm-12 col-12`,
      value: name,
    },
    {
      label: 'Program',
      name: 'programId',
      type: 'text',
      // required: true,
      rowNumber: 3,
      disabled: true,
    },

    {
      label: 'Note Name',
      name: 'noteName',
      type: 'text',
      // required: true,
      disabled: true,
      rowNumber: 3,
      validation: validator.NAME_VALIDATION,
    },
    {
      sectionHeading: 'Service Description',
      rowNumber: 5,
    },
    {
      label: 'Service Description',
      name: 'serviceId',
      type: 'text',
      // required: true,
      
      rowNumber: 5,
      disabled: true,
    },
    {
      sectionHeading: 'Other Details',
      rowNumber: 6,
    },
    {
      label: 'Long Term Objectives',
      name: 'longTermObjectives',
      type: 'textarea',
      // required: true,
      disabled: true,
      rowNumber: 7,
      minRows: 4,
    },
    {
      label: 'Goals/Service',
      name: 'goals',
      type: 'textarea',
      disabled: true,
      // required: true,
      rowNumber: 8,
    },
    {
      label: 'Reason For Notes',
      name: 'reasonForNotes',
      type: 'textarea',
      disabled: true,
      // required: true,
      rowNumber: 9,
    },
    {
      label: 'Criteria For Completion',
      name: 'criteriaForCompletion',
      type: 'textarea',
      disabled: true,
      // required: true,
      rowNumber: 10,
    },
    {
      label: 'Materials Required',
      name: 'materialsRequired',
      type: 'textarea',
      disabled: true,
      // required: true,
      rowNumber: 11,
    },
    {
      sectionHeading: 'Evaluation',
      rowNumber: 13,
    },
    {
        label: "",
        name: "evaluation",
        type: "checkbox",
        options: [
            { label: "Bathing", value: 'bathing' },
            { label: "Grooming", value: 'grooming' },
            { label: "Shaving", value: 'shaving' },
            { label: "Haircare", value: 'haircare' },
            { label: "Oral Hygiene", value: 'oralHygiene' },
            { label: "Skincare", value: 'skinCare' },
            { label: "Meal Prep", value: 'mealPrep' },
            { label: "Housekeeping", value: 'houseKeeping' },
            { label: "Laundry", value: 'laundry' },
            { label: "Errands/Shopping", value: 'errands' },
            { label: "Ambulation", value: 'ambulation' },
            { label: "Personal Care", value: 'personalCare' },
            { label: "Exercise", value: 'exercise' },
            { label: "Turn & Reposition", value: 'turnNrepo' },
            { label: "Vital Signs", value: 'vitalSigns' },
            { label: "Catheter Care", value: 'cathCare' },
            { label: "Appointments", value: 'appointments' },
            { label: "Safety", value: 'safety' },
        ],
        required: false,
        rowNumber: 14
    },

    {
      sectionHeading: 'Goal Scores',
      rowNumber: 15,
    },
      {
      sectionHeading: 'Next Session',
      rowNumber:40,
    },
    {
        label: 'Next Session',
        name: 'nextSession',
        type: 'date',
        // required: true,
        rowNumber: 41,
        maxDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
        minDate: new Date(new Date().setDate(new Date().getDate() + 1))
    },
  ]
}

export const EDIT_NOTES_FORM_INPUTS = (serviceDescriptionList) => {
  return [
    {
      sectionHeading: 'Details',
      rowNumber: 3,
    },
    {
      label: 'Program',
      name: 'programId',
      type: 'text',
      required: true,
      rowNumber: 4,
      disabled: true,
    },
    {
      label: 'Client',
      name: 'clientId',
      type: 'text',
      required: true,
      rowNumber: 4,
      disabled: true,
    },
    {
      label: 'Note Name',
      name: 'noteName',
      type: 'text',
      required: true,
      rowNumber: 4,
      validation: validator.NAME_VALIDATION,
    },
    {
      sectionHeading: 'Service Description',
      rowNumber: 5,
    },
    {
      label: 'Service Description',
      name: 'serviceId',
      type: 'select',
      options: serviceDescriptionList,
      required: true,
      rowNumber: 5,
      disabled: true,
    },
    {
      sectionHeading: 'Other Details',
      rowNumber: 6,
    },
    {
      label: 'Long Term Objectives',
      name: 'longTermObjectives',
      type: 'textarea',
      required: true,
      rowNumber: 7,
      minRows: 4,
    },
    {
      label: 'Goals/Service',
      name: 'goals',
      type: 'textarea',
      required: true,
      rowNumber: 8,
    },
    {
      label: 'Reason For Notes',
      name: 'reasonForNotes',
      type: 'textarea',
      required: true,
      rowNumber: 9,
    },
    {
      label: 'Criteria For Completion',
      name: 'criteriaForCompletion',
      type: 'textarea',
      required: true,
      rowNumber: 10,
    },
    {
      label: 'Materials Required',
      name: 'materialsRequired',
      type: 'textarea',
      required: true,
      rowNumber: 11,
    },
        {
      label:"Client lives with:",
      name:"clientLivesWith",
      rowNumber: 12,
      type:"select",
      options:[
        {label:"Client Lives Alone", value:"alone"},
        {label:"Client Lives With family, but family is unavailable", value:"withfamilybutunavail"},
        {label:"Client Lives With family, but family is unable to provide care", value:"withfamilybutunabletocare"},
        {label:"Client Lives With family, but family needs assistance", value:"withfamilybutassistance"},
      ]
    },
    {
      sectionHeading: 'Goals',
      rowNumber: 13,
    },
    {
      type: 'CaregiverNotesDialog',
      rowNumber: 14,
    },
  ]
}

export const EDIT_NOTE_ENTRY_FORM_INPUTS = (name: string) => {
  return [
    {
      sectionHeading: 'Data Collection Detail',
      rowNumber: 2,
    },
    // {
    //   label: 'Data Collection Date',
    //   name: 'startDate',
    //   type: 'date',
    //   required: true,
    //   rowNumber: 1,
    //   className: `col-lg-3 col-md-6 col-sm-6`,
    // },
    // {
    //   label: 'Begin Time',
    //   name: 'beginTime',
    //   type: 'time',
    //   required: true,
    //   rowNumber: 2,
    //   className: `col-lg-3 col-md-6 col-sm-6`,
    // },
    // {
    //   label: 'End Time',
    //   name: 'endTime',
    //   type: 'time',
    //   required: true,
    //   rowNumber: 3,
    //   className: `col-lg-3 col-md-6 col-sm-6`,
    // },
    // {
    //   label: 'Location',
    //   name: 'location',
    //   type: 'text',
    //   required: true,
    //   rowNumber: 4,
    //   className: `col-lg-6 col-md-6 col-sm-6`,
    //   disabled: true,
    // },
    {
      label: 'Entered By',
      name: 'enteredBy',
      type: 'textLabel',
      // required: true,
      rowNumber: 2,
      value: name,
    },
     {
      label: 'Program',
      name: 'programId',
      type: 'text',
      // required: true,
      rowNumber: 3,
      disabled: true,
    },

    {
      label: 'Note Name',
      name: 'noteName',
      type: 'text',
      // required: true,
      disabled: true,
      rowNumber: 3,
      validation: validator.NAME_VALIDATION,
    },
    {
      sectionHeading: 'Service Description',
      rowNumber: 5,
    },
    {
      label: 'Service Description *',
      name: 'serviceId',
      type: 'text',
      // required: true,
      
      rowNumber: 5,
      disabled: true,
    },
    {
      sectionHeading: 'Other Details',
      rowNumber: 6,
    },
    {
      label: 'Long Term Objectives',
      name: 'longTermObjectives',
      type: 'textarea',
      // required: true,
      disabled: true,
      rowNumber: 7,
      minRows: 4,
    },
    {
      label: 'Goals/Service',
      name: 'goals',
      type: 'textarea',
      disabled: true,
      // required: true,
      rowNumber: 8,
    },
    {
      label: 'Reason For Notes',
      name: 'reasonForNotes',
      type: 'textarea',
      disabled: true,
      // required: true,
      rowNumber: 9,
    },
    {
      label: 'Criteria For Completion',
      name: 'criteriaForCompletion',
      type: 'textarea',
      disabled: true,
      // required: true,
      rowNumber: 10,
    },
    {
      label: 'Materials Required',
      name: 'materialsRequired',
      type: 'textarea',
      disabled: true,
      // required: true,
      rowNumber: 11,
    },
    {
      sectionHeading: 'Evaluation',
      rowNumber: 13,
    },
    {
        label: "",
        name: "evaluation",
        type: "checkbox",
        options: [
            { label: "Bathing", value: 'bathing' },
            { label: "Grooming", value: 'grooming' },
            { label: "Shaving", value: 'shaving' },
            { label: "Haircare", value: 'haircare' },
            { label: "Oral Hygiene", value: 'oralHygiene' },
            { label: "Skincare", value: 'skinCare' },
            { label: "Meal Prep", value: 'mealPrep' },
            { label: "Housekeeping", value: 'houseKeeping' },
            { label: "Laundry", value: 'laundry' },
            { label: "Errands/Shopping", value: 'errands' },
            { label: "Ambulation", value: 'ambulation' },
            { label: "Personal Care", value: 'personalCare' },
            { label: "Exercise", value: 'exercise' },
            { label: "Turn & Reposition", value: 'turnNrepo' },
            { label: "Vital Signs", value: 'vitalSigns' },
            { label: "Catheter Care", value: 'cathCare' },
            { label: "Appointments", value: 'appointments' },
            { label: "Safety", value: 'safety' },
        ],
        required: false,
        rowNumber: 14
    },
    {
      sectionHeading: 'Goal Scores',
      rowNumber: 15,
    },
    {
      sectionHeading: 'Next Session',
      rowNumber: 40,
    },
    {
        label: 'Next Session',
        name: 'nextSession',
        type: 'date',
        // required: true,
        rowNumber: 41,
        maxDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
        minDate: new Date(new Date().setDate(new Date().getDate() + 1))
    },
  ]
}
